//-- Get Line Height

export const getLineHeight = elem => {
  let lh = elem.css('line-height')
  if (lh === 'normal') {
    // Normal line heights vary from browser to browser. The spec recommends
    // a value between 1.0 and 1.2 of the font size. Using 1.1 to split the diff.
    lh = parseInt(elem.css('font-size')) * 1.1;
  }
  return parseInt(lh);
}



// WEBPACK FOOTER //
// ./src/ac/js/helpers/getLineHeight.js